module.exports = __webpack_public_path__ + "static/37-thedress-feb2015-41ba755d1c3c10eeeee258348ae4a604.jpg";